import { Leaf, WheatOff } from "lucide-react";
import {
  FOOD_CATEGORY_LABELS,
  type FoodDietary,
} from "@/lib/events/food-dietary";
import { cn } from "@/lib/utils";

export function FoodDietaryBadges({
  dietary,
}: {
  dietary?: FoodDietary | null;
}) {
  if (!dietary) return null;
  const veg = dietary.category === "vegetarian" || dietary.category === "vegan";
  const animal =
    dietary.category === "non_vegetarian" ||
    dietary.category === "contains_egg";
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
      <span className="inline-flex items-center gap-1.5">
        {veg || animal ? (
          <span
            aria-hidden
            className={cn(
              "flex size-3.5 shrink-0 items-center justify-center border bg-white",
              veg
                ? "border-green-700 text-green-700"
                : "border-amber-900 text-amber-900",
            )}
          >
            {veg ? (
              <span className="size-1.5 rounded-full bg-current" />
            ) : (
              <span className="size-0 border-x-[4px] border-b-[6px] border-x-transparent border-b-current" />
            )}
          </span>
        ) : null}
        {dietary.category === "vegan" ? (
          <Leaf className="size-3.5" aria-hidden />
        ) : null}
        {FOOD_CATEGORY_LABELS[dietary.category]}
      </span>
      {dietary.glutenFree ? (
        <span className="inline-flex items-center gap-1">
          <WheatOff className="size-3.5" aria-hidden />
          Gluten-free
        </span>
      ) : null}
    </div>
  );
}
